<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="bank-transfer-information">
      <Title jpn="Payment Completed" />

      <div class="area_box">
        <div class="flex-box">
          <span class="text top">Thank you for purchasing points.</span>
          <span class="text top">Please send the money to the following email address within 3 days.</span>
        </div>
        <div class="transfer-information top-30">
          <span class="text">Amount of remittance</span>
          <GrayBack class="shadow-box value" opacity="_60">
            <span class="price">¥{{dispSalePointPrice}}</span>
          </GrayBack>
          <span class="text top-30">Amount of remittance Email address</span>
          <GrayBack class="shadow-box bank-account" opacity="_60">
            <div class="row" style="margin: auto;">
              <span class="value">yugioh@iranoan.com</span>
            </div>
          </GrayBack>
        </div>
        <div class="flex-box">
          <span class="text bottom top-30">After confirming the remittance, the points will be reflected within the same day at the shortest.</span>
        </div>
      </div>
      <BlackGradationButton
        class="square-button top-30"
        text="HOME"
        @handleSquareBtnClick="goToTop"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
} from '@/common/util/format';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import GrayBack from '@/components/molecules/GrayBack.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import Title from '@/components/molecules/Title.vue';

export default {
  name: 'PaygeTransferInformation',

  beforeRouteLeave(to, from, next) {
    if (to.name === 'ConfirmBuyPoint') {
      next(false);
    } else {
      next();
    }
  },

  components: {
    BaseTemplate,
    GrayBack,
    BlackGradationButton,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentBank: 'bank/currentBank',
    }),
    dispSalePointPrice() {
      if (this.currentBank) {
        return separateCharacterNumber(parseInt(this.currentBank.price, 10));
      }
      return 0;
    },
  },

  created() {
    this.$store.dispatch('bank/setCurrentBank');
  },

  methods: {
    goToTop() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-box {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.area_box {
  max-width: 680px;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
}
.price {
  color: $white;
}
.bank-transfer-information{
  width: 100%;
  max-width: 1800px;
  min-height: 100%;
  padding: 30px 20px;
  margin: 0px auto;
  text-align: center;
  .text{
    display: inline-block;
    font-family: $notoSans;
    font-size: 16px;
    color: $white;
    white-space: nowrap;
    &.top{
      line-height: 28.8px;
    }
    &.bottom{
      line-height: 32.4px;
    }
  }
  .top-30{
    margin-top: 30px;
  }
  .transfer-information{
    width: 100%;
    .text{
      font-size: 18px;
    }
    .shadow-box{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-top: 10px;
      border-radius: 6px;
      &.value{
        height: 60px;
        font-family: $notoSerif;
        font-size: 30px;
        font-weight: 700;
        color: $white;
      }
      &.bank-account{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 20px;
        font-family: $notoSans;
        font-size: 13px;
        color: $white;
        .row{
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          margin: 0px;
          & + .row{
            margin-top: 10px;
          }
          .key{
            text-align: left;
            min-width: 93px;
          }
          .value{
            margin-left: 10px;
            font-size: 18px;
            font-weight: 700;
          }
        }
      }
    }
  }
  .square-button{
    width: 200px;
    height: 50px;
    margin: 30px auto 0px;
  }
}

@media screen and  (max-width: $tabletWidth) {
  .flex-box {
    .text {
      white-space: normal;
      font-size: 14px;
    }
  }
  .bank-transfer-information{
    padding: 30px 10px;
  }
}
</style>
